module.exports = __webpack_public_path__ + "static/img/adress2.ff3ee25.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/adress2.png
// module id = 0vD3
// module chunks = 0